import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Trophy, Star } from 'lucide-react';
import { Section } from './Shared';
type PlanId = 'master' | 'inicial';
const plans: {
  id: PlanId;
  emoji: string;
  name: string;
  desc: string;
  ideal: string;
  oldPrice: string;
  price: string;
  href: string;
  recommended: boolean;
}[] = [{
  id: 'master',
  emoji: '🏆',
  name: 'MASTER KIT PROFESIONAL',
  desc: '1 Tomo + 3 Bonus + Kit Fabricante Pro',
  ideal: 'Ideal para: aprender a usar el péndulo, atender consultas Y fabricar tu propio péndulo para vender',
  oldPrice: '$99.000',
  price: '$27.990 ARS',
  href: 'https://www.lumenakasha.com/cart/46799418261693:1',
  recommended: true
}, {
  id: 'inicial',
  emoji: '📘',
  name: 'KIT EMPRENDEDOR INICIAL',
  desc: '1 Tomo + 3 Bonus',
  ideal: 'Ideal para: aprender el método y arrancar con tus primeras consultas pagas desde hoy',
  oldPrice: '$81.000',
  price: '$19.990 ARS',
  href: 'https://www.lumenakasha.com/cart/46799129313469:1',
  recommended: false
}];
export const Pricing = () => {
  const [selected, setSelected] = useState<PlanId>('master');
  const selectedPlan = plans.find(p => p.id === selected)!;
  return <Section id="pricing" className="bg-brand-surfaceLight/60 rounded-3xl my-12 border border-brand-gold/20" data-id="element-372">
      <div className="text-center mb-10" data-id="element-373">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-plum" data-id="element-374">
          ELEGÍ TU <span className="purple-gradient-text" data-id="element-375">KIT</span>
        </h2>
        <p className="text-brand-text/70 mt-3 text-sm md:text-base" data-id="element-376">
          ⏰ El precio de lanzamiento cierra pronto. Después sube $8.000.
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-377">
        {plans.map(plan => {
        const isSelected = selected === plan.id;
        return <motion.button key={plan.id} type="button" onClick={() => setSelected(plan.id)} whileTap={{
          scale: 0.99
        }} aria-pressed={isSelected} className={`w-full text-left rounded-2xl md:rounded-3xl p-4 md:p-6 border-2 transition-all duration-300 ${isSelected ? 'border-brand-gold bg-brand-surface shadow-[0_0_24px_rgba(56,189,248,0.2)]' : 'border-brand-gold/20 bg-brand-surfaceLight/70 hover:border-brand-gold/50'}`} data-id="element-378">
              <div className="flex items-start gap-3 md:gap-4" data-id="element-379">
                <div className="shrink-0 mt-1" data-id="element-380">
                  <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-brand-gold' : 'border-brand-gold/40'}`} data-id="element-381">
                    {isSelected && <motion.div initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-brand-gold" data-id="element-382" />}
                  </div>
                </div>

                <div className="flex-1 min-w-0" data-id="element-383">
                  {plan.recommended && <div className="flex items-center gap-1.5 mb-1.5 text-brand-gold" data-id="element-384">
                      <Trophy className="w-4 h-4 fill-brand-gold" data-id="element-385" />
                      <Star className="w-3.5 h-3.5 fill-brand-gold" data-id="element-386" />
                      <span className="text-[10px] md:text-xs font-bold tracking-wider uppercase" data-id="element-387">
                        Más elegido
                      </span>
                    </div>}

                  <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1" data-id="element-388">
                    <div className="min-w-0" data-id="element-389">
                      <h3 className="font-serif font-bold text-sm md:text-lg text-brand-plum leading-tight" data-id="element-390">
                        <span className="mr-1.5" data-id="element-391">{plan.emoji}</span>
                        {plan.name}
                      </h3>
                      <p className="text-xs md:text-sm text-brand-text/70 mt-1" data-id="element-392">
                        {plan.desc}
                      </p>
                      <p className="text-[11px] md:text-xs text-brand-purple font-medium mt-1.5" data-id="element-393">
                        {plan.ideal}
                      </p>
                    </div>

                    <div className="text-right shrink-0" data-id="element-394">
                      <p className="text-xs md:text-sm text-brand-text/40 line-through leading-none" data-id="element-395">
                        {plan.oldPrice}
                      </p>
                      <p className={`font-serif font-bold text-lg md:text-2xl leading-tight mt-1 ${isSelected ? 'text-brand-purple' : 'text-brand-text'}`} data-id="element-396">
                        {plan.price}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.button>;
      })}

        <motion.a href={selectedPlan.href} animate={{
        scale: [1, 1.025, 1],
        y: [0, -2, 0]
      }} transition={{
        duration: 2.4,
        ease: 'easeInOut',
        repeat: Infinity
      }} whileHover={{
        scale: 1.04,
        y: -3,
        transition: {
          duration: 0.25
        }
      }} whileTap={{
        scale: 0.98
      }} className="mt-6 w-full inline-flex items-center justify-center px-6 py-4 md:py-5 text-sm md:text-lg font-bold text-brand-dark gold-gradient-bg rounded-full animate-glow-pulse relative overflow-hidden cta-shimmer shadow-[0_0_20px_rgba(56,189,248,0.4)]" data-id="element-397">
          <span className="relative z-10" data-id="element-398">
            → QUIERO EL{' '}
            {selectedPlan.id === 'master' ? 'MASTER KIT PROFESIONAL' : 'KIT EMPRENDEDOR INICIAL'}
          </span>
        </motion.a>

        <p className="text-center text-xs md:text-sm text-brand-text/60 pt-2" data-id="element-399">
          🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro · 💳
          Mercado Pago
        </p>
      </div>
    </Section>;
};